{{ element.label }} <sup *ngIf="element.isRequired">*</sup>
